// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
nav.cald_header {
  font-family: "72-Condensed";
}

nav.cald_header {
  height: 4rem;
  min-height: 0.5rem;
  z-index: 100;
  margin: 0rem;
  padding: 0rem;
  position: static;
  background-color: white;
  color: #000000;
}
nav.cald_header ul {
  padding: 0 1.5rem;
}
nav.cald_header ul li a {
  margin: 0 3.1rem;
  padding: 0.8rem 0;
  border: none;
  font-size: 1.4rem;
  letter-spacing: 0;
  color: #000000;
  background-color: white;
  cursor: pointer;
}
nav.cald_header ul li a.first-menu {
  margin: 0 3.1rem 0 0;
}
nav.cald_header ul li.dropdown {
  display: inline-block;
}
nav.cald_header ul li.dropdown:hover {
  border: none;
  background-color: white;
  border-bottom: solid 0.2rem rgb(0, 171, 227);
  color: black;
  border-radius: 0rem;
}
nav.cald_header ul li.dropdown:hover .dropdown-content {
  display: block;
}
nav.cald_header ul li.dropdown .dropdown-content {
  display: none;
  position: absolute;
  top: 3.8rem;
  background-color: white;
  min-width: 19.5rem;
  box-shadow: 0rem 0.8rem 1.6rem 0rem rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
nav.cald_header ul li.dropdown .dropdown-content a {
  text-decoration: none;
  display: block;
  color: #000000;
  margin: 0rem;
  width: 100%;
  padding-left: 1.5rem;
}
nav.cald_header ul li.dropdown .dropdown-content a:hover {
  color: #000000;
  background-color: rgb(0, 171, 227);
  width: 100%;
  margin: 0rem;
  padding-left: 1.5rem;
  cursor: pointer;
}
nav.cald_header .cald_header_menuitem_selected {
  border: none;
  border-bottom: solid 0.2rem rgb(0, 171, 227);
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/shared/mainMenu/main-menu.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAaA;EACI,2BAAA;ACfJ;;AAFA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EAEA,cAAA;AAIF;AAHE;EACE,iBAAA;AAKJ;AAHM;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AAKR;AAJQ;EACE,oBAAA;AAMV;AAHM;EACE,qBAAA;AAKR;AAJQ;EACE,YAAA;EACA,uBAAA;EACA,4CAAA;EACA,YAAA;EACA,mBAAA;AAMV;AALU;EACE,cAAA;AAOZ;AAJQ;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,sDAAA;EACA,aAAA;AAMV;AALU;EACE,qBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AAOZ;AANY;EACE,cAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AAQd;AADE;EACE,YAAA;EACA,4CAAA;AAGJ","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\nnav.cald_header {\n  height: 4rem;\n  min-height: 0.5rem;\n  z-index: 100;\n  margin: 0rem;\n  padding: 0rem;\n  position: static;\n  background-color: white;\n  @extend %font-condensed;\n  color: #000000;\n  ul {\n    padding: 0 1.5rem;\n    li {\n      a {\n        margin: 0 3.1rem;\n        padding: 0.8rem 0;\n        border: none;\n        font-size: 1.4rem;\n        letter-spacing: 0;\n        color: #000000;\n        background-color: white;\n        cursor: pointer;\n        &.first-menu {\n          margin: 0 3.1rem 0 0;\n        }\n      }\n      &.dropdown {\n        display: inline-block;\n        &:hover {\n          border: none;\n          background-color: white;\n          border-bottom: solid 0.2rem rgba(0, 171, 227, 1.0);\n          color: black;\n          border-radius: 0rem;\n          .dropdown-content {\n            display: block;\n          }\n        }\n        .dropdown-content {\n          display: none;\n          position: absolute;\n          top: 3.8rem;\n          background-color: white;\n          min-width: 19.5rem;\n          box-shadow: 0rem 0.8rem 1.6rem 0rem rgba(0, 0, 0, 0.2);\n          z-index: 1000;\n          a {\n            text-decoration: none;\n            display: block;\n            color: #000000;\n            margin: 0rem;\n            width: 100%;\n            padding-left: 1.5rem;\n            &:hover {\n              color: #000000;\n              background-color: rgba(0, 171, 227, 1.0);\n              width: 100%;\n              margin: 0rem;\n              padding-left: 1.5rem;\n              cursor: pointer;\n            }\n          }\n        }\n      }\n    }\n  }\n  .cald_header_menuitem_selected {\n    border: none;\n    border-bottom: solid 0.2rem rgba(0, 171, 227, 1.0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
